// hooks/billing/useTiers.js
import { useCallback, useEffect, useState } from 'react';
import BillingService from '../../services/billing.service';

/**
 * useTiers — public tier catalog (`GET /tiers`).
 *
 * Returns a list of TierItem objects (camelCase). Stable, doesn't
 * depend on user context.
 *
 * @param {Object} [options]
 * @param {boolean} [options.auto=true] auto-fetch on mount
 */
export function useTiers({ auto = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(auto);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    const result = await BillingService.listTiers();
    if (result.success) {
      setData(result.data?.items ?? []);
    } else {
      setError(result);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (auto) refetch();
  }, [auto, refetch]);

  return { data, loading, error, refetch };
}

export default useTiers;
